import SimpleLightbox from "simplelightbox";


const LINKS_WITH_IMAGES = 'a[href$="jpg"], a[href$="jpeg"], a[href$="webp"], a[href$="png"], a[href$="avif"]';


$(LINKS_WITH_IMAGES).each((i, link) => {
    const newHref = $(link).attr('href').replace(/-[\d]+x[\d]+/, '');
    $(link).attr('href', newHref);
});


const lightbox = new SimpleLightbox(LINKS_WITH_IMAGES, {
    navText: [
        '<span class="lightbox-navigation-button icon-prev"></span>',
        '<span class="lightbox-navigation-button icon-next"></span>'
    ],

    closeText: '<span class="lightbox-navigation-button icon-close"></span>'
});

const hash = window.location.hash.replace('#', '').match(/pid=(\d+)/);

if (hash && hash[1]) {
    window.location.hash = '';
    lightbox.open($(LINKS_WITH_IMAGES).eq(hash[1] - 1));
}

